import angular from "angular";
import toastr from 'toastr';

angular.module("documents_reports")

    .controller('DocumentsReportsListCtrl', ['$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', 'uiGridConstants', '$filter', 'LoginService', '$stateParams', '$state', 'logService',
        function ($rootScope, $scope, Restangular, gridService, modalService, uiGridConstants, $filter, LoginService, $stateParams, $state, logService) {

        $rootScope.title = $filter('translate')('documents_reports.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('documents_reports.subtitleList') }
        ];

        Restangular.all('DocumentsTypes').getList().then(function (results) {
            $scope.documentsTypes = results;
        }, function (response) {
            $scope.errorMessage = response.message;
        });          

        $scope.documents_reports_filter = {
            name: "",
            description: "",
            code: "",
            type: ""
        };

        //reseteamos los filtros del buscador
        if (!angular.isDefined($stateParams.reset) || $stateParams.reset == null) $stateParams.reset = true;

        logService.debug($stateParams.reset);

        if ($stateParams.reset != false) {
            localStorage.removeItem("persons_filters");
        } else {
            var savedFilters = localStorage.getItem("documents_reports_filter");
            logService.debug(savedFilters);
            if (savedFilters != null) {
                $scope.documents_reports_filter = JSON.parse(savedFilters);
            }
        }

        $scope.gridOptionsDocuments = {
            pdfTitle: $filter('translate')('documents_reports.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            paginationPageSizes: [20, 50, 100],
            paginationPageSize: 100,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                { name: 'name', displayName: $filter('translate')('documents_reports.name'), width: 200, enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                { name: 'description', displayName: $filter('translate')('documents_reports.description'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                { name: 'jasper_path', displayName: $filter('translate')('documents_reports.path'), width: 500, cellTemplate: '<span>{{row.entity.jasper_path}}</span>', enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                { name: 'FK_documents_documents_types.name', displayName: $filter('translate')('documents_reports.type'),  enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                { name: 'usage_count', displayName: $filter('translate')('documents_reports.usage_count'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                {
                    name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('general.button_duplicate'), action: 'ng-click="grid.appScope.duplicate(row.entity.id)"', cssIconClass: "fa fa-copy" },
                        { title: $filter('translate')('general.button_edit'), action: 'ui-sref="documents_reports.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                        { title: $filter('translate')('general.button_delete'), action: 'ng-click="grid.appScope.BorrarDialog(row.entity.id,row.entity.name);"', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                },

            ],
            getData: function (options) {
                if ($scope.documents_reports_filter.name != "") options.name = $scope.documents_reports_filter.name;
                if ($scope.documents_reports_filter.description != "") options.description = $scope.documents_reports_filter.description;
                if ($scope.documents_reports_filter.code != "") options.code = $scope.documents_reports_filter.code;
                if ($scope.documents_reports_filter.type != "") options.type = $scope.documents_reports_filter.type;

                localStorage.setItem("documents_reports_filter", JSON.stringify($scope.documents_reports_filter));

                return Restangular.all('Documents').getList(options);
            }

        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("documents_reports.edit", { id: rowEntity.id });
        }

        $scope.searchDocumentsReports = function () {
            if (angular.isDefined($scope.gridOptionsDocuments.loadData)) {
                $scope.gridOptionsDocuments.loadData(false);
            }
        }

        $scope.clearFilters = function () {
            $scope.documents_reports_filter = {
                name: "",
                description: "",
                code: "",
                type: ""
            };

            $scope.gridOptionsDocuments.loadData(false);
        }

        $scope.BorrarDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('documents_reports.button_delete'),
                message: $filter('translate')('documents_reports.delete_message') + " " + name + "?",
                onAccept: function () {
                    Restangular.one('Documents', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('documents_reports.delete_success'));
                        $scope.gridOptionsDocuments.gridApi.core.raise.itemDeleted($scope);

                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });
        };

        $scope.duplicate = function (id) {
            Restangular.all('Documents').customPOST({}, "DuplicateDocument", { id: id }).then(function (result) {
                if (angular.isDefined(result.id)) {
                    toastr.success($filter('translate')('documents_reports.create_success'));
                    $scope.gridOptionsDocuments.loadData();
                } else {
                    $scope.errorMessage = result.message;
                }
            });
        }
    }]);